import { render } from "./Courses_Icon.vue?vue&type=template&id=6fee5f53&scoped=true"
import script from "./Courses_Icon.vue?vue&type=script&lang=js"
export * from "./Courses_Icon.vue?vue&type=script&lang=js"

import "./Courses_Icon.vue?vue&type=style&index=0&id=6fee5f53&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fee5f53"]])

export default __exports__